import React from 'react'

import { Box, DisplayPosition, Space } from '@gousto-internal/citrus-react'

import { CWCFloatingPills, FloatingPillConfig } from '../../CWCFloatingPills/CWCFloatingPills'
import { CWCHowItWorksCardLabels } from './CWCHowItWorksCardLabels'
import boxSizeJpg from '../assets/hiw-boxsize.jpg'
import boxSizeWebp from '../assets/hiw-boxsize.webp'
import skipOrCancelIcon from '../assets/skip-or-cancel.svg'
import swapRecipesIcon from '../assets/swap-recipes.svg'

export type CWCHowItWorksStaticCardProps = {
  stepNumber: number
  title: string
  body: string
}

// The three decorative "flex your plan" pills overlaid on the static step image (per Figma
// 320:11475): an "Adjust portions" pill with the 5-bar portions graphic, plus "Swap recipes" and
// "Skip or cancel" pills each with a 12px icon.
const PILLS: FloatingPillConfig[] = [
  { label: 'Adjust portions', graphic: 'portions' },
  {
    label: 'Swap recipes',
    graphic: <img src={swapRecipesIcon} alt="" width="12" height="12" />,
  },
  {
    label: 'Skip or cancel',
    graphic: <img src={skipOrCancelIcon} alt="" width="12" height="12" />,
  },
]

export function CWCHowItWorksStaticCard({ stepNumber, title, body }: CWCHowItWorksStaticCardProps) {
  return (
    <Box width={['240px', null, null, null, '260px']}>
      <Box
        position={DisplayPosition.Relative}
        width="100%"
        height="380px"
        style={{ borderRadius: '16px', overflow: 'hidden', background: '#11161B' }}
      >
        <picture>
          <source srcSet={boxSizeWebp} type="image/webp" />
          <img
            src={boxSizeJpg}
            alt="A woman using the Gousto app on a smartphone to change their box size and subscription settings"
            style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </picture>
        <CWCFloatingPills
          pills={PILLS}
          align="right"
          testId="howItWorksFloatingPills"
          showGradient={false}
        />
      </Box>
      <Space size={4} />
      <CWCHowItWorksCardLabels stepNumber={stepNumber} title={title} body={body} />
    </Box>
  )
}
